export class DbConfig {
	
}
